/* unplugin-vue-components disabled */import { render } from "./Billing.vue?vue&type=template&id=2045c760"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"

import "./Billing.vue?vue&type=style&index=0&id=2045c760&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__